export default function CreatePoButton({ onClick, label = "CREATE PO", disabled = false }) {
  return (
    <button
      data-tour="po-create"
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="px-4 py-1.5 bg-blue-600 rounded-md shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] inline-flex justify-start items-center gap-2 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
        <path
          d="M9.83333 4.66667C10.1095 4.66667 10.3333 4.89052 10.3333 5.16667C10.3333 5.44281 10.1095 5.66667 9.83333 5.66667H0.5C0.223858 5.66667 0 5.44281 0 5.16667C0 4.89052 0.223858 4.66667 0.5 4.66667H9.83333Z"
          fill="white"
        />
        <path
          d="M4.66667 9.83333V0.5C4.66667 0.223858 4.89052 0 5.16667 0C5.44281 0 5.66667 0.223858 5.66667 0.5V9.83333C5.66667 10.1095 5.44281 10.3333 5.16667 10.3333C4.89052 10.3333 4.66667 10.1095 4.66667 9.83333Z"
          fill="white"
        />
      </svg>
      <span className="text-center justify-center text-white font-OpenSansSemiBold font-[600] text-[14px] leading-[20px] tracking-[0.14px] capitalize">
        {label}
      </span>
    </button>
  );
}
